module.exports = __webpack_public_path__ + "img/nav_(5).0fb1efcd.png";